import Vue from "vue";
import gaService from "./ga.service";

export default {
    async getGamesAsync() {
        return (await Vue.http.get("/api/softgamings/games")).data;
    },
    async openSession(options = { lang: "en", game }) {
        const gameId = "SoftGamings";
        gaService.send("games", "softgamings", gameId);
        return (await Vue.http.post("/api/softgamings/session/open", Object.assign({}, options))).data;
    },
    async closeSession() {
        return (await Vue.http.post("/api/softgamings/session/close")).data;
    }
};


// WEBPACK FOOTER //
// ./_common/services/softgamings.service.js